import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.etf-tip-content {
    color: #000000;
    max-width: calc(8px * 79);
    width: 100%;
    padding: 8px;
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    -webkit-filter: contrast(21);
            filter: contrast(21);
    line-height: 1.15;
    display: flex;
}
.tooltip-img {
    padding-left: 2px;
}
.etf-tip-title {
    color: #000000;
    font-family: 'Nimbus Sans', sans-serif;
    line-height: 1;
    padding: 8px;
    justify-content: left;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    float: left;
}
.label-superscript {
    font-size: 14px;
    left: 2px;
}
@media (max-width: 720px) {
    display: table-cell;
}
`;

export default styles;